import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'underscore';

export class Checkbox extends React.Component {
  // for now eslint-plugin-react doesn't recognize `getDerivedStateFromProps`
  // which is introduced in React 16.3
  static propTypes = {
    inline: PropTypes.bool,
    checked: PropTypes.bool,
    indeterminate: PropTypes.bool,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
    ]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string, // eslint-disable-line
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string,
  };

  static defaultProps = {
    inline: false,
    checked: false,
    indeterminate: false,
    children: null,
    className: 'checkbox',
    disabled: false,
    id: null,
    name: null,
    value: '',
    ariaLabel: undefined,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      id: nextProps.id || prevState.id || _.uniqueId('checkbox-'),
    };
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (this.props.indeterminate === true) {
      this.el.indeterminate = this.props.indeterminate;
    }
  }

  componentDidUpdate(previousProps) {
    if (previousProps.indeterminate !== this.props.indeterminate) {
      this.el.indeterminate = this.props.indeterminate;
    }
  }

  render() {
    const {
      id,
    } = this.state;

    const {
      inline,
      checked,
      children,
      className,
      disabled,
      name,
      value,
      onChange,
      ariaLabel,
    } = this.props;

    return inline ? (
      <label className={classNames('checkbox-inline', { disabled })} htmlFor={id}>
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          ref={(el) => { this.el = el; }}
          aria-label={ariaLabel}
        />
        {children}
      </label>) : (
        <div className={classNames(className)} >
          <label htmlFor={id}>
            <input
              type="checkbox"
              checked={checked}
              disabled={disabled}
              id={id}
              name={name}
              value={value}
              onChange={onChange}
              ref={(el) => { this.el = el; }}
              aria-label={ariaLabel}
            />
            {children}
          </label>
        </div>);
  }
}
